import { ToggleDropdownDirective } from './toggle-dropdown.directive';
import { SetImageDirective } from './set-image/set-image.directive';
import { SetFundedColorDirective } from './set-funded-color/set-funded-color.directive';
import { CollapseDirective } from './collapse/collapse.directive';
import { PhoneNumberDirective } from './phone-number/phone-number.directive';
import { DragAndDropDirective } from './drag-and-drop/drag-and-drop.directive';
import { NumbersOnlyDirective } from './numbers-only/numbers-only.directive';

export const Directives = [
  ToggleDropdownDirective,
  SetImageDirective,
  SetFundedColorDirective,
  CollapseDirective,
  PhoneNumberDirective,
  DragAndDropDirective,
  NumbersOnlyDirective
];
